import { Node } from '@tiptap/core'
import { VueNodeViewRenderer, mergeAttributes } from "@tiptap/vue-3"
import View from "./View.vue"

export default Node.create({
  name: 'YoutubeVideo',

  group: 'block',

  atomic: true,

  draggable: true,

  addAttributes() {
    return {
      src: {
        default: null,
      },
      title: {
        default: 'youtube video'
      },
      width: {
        default: '640px',
      },
      height: {
        default: '360',
      },
      justify: {
        default: 'center',
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'tt-youtube-video',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['tt-youtube-video', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return VueNodeViewRenderer(View)
  }
})
